export const sortByPriceAscending = <T>(options: T & { price: number }[]) => {
  const isArray = Array.isArray(options);

  if (!isArray) return [];

  return options.sort((a, b) => a.price - b.price);
};
